import React from 'react';

import { SSRBaseGrid } from '../ssr-base-grid';
import {
  RequestNumberColumn,
  OrderNumberColumn,
  CreateDateColumn,
  CustomerNameColumn,
  CustomerEmailColumn,
  AmountColumn,
  StoreIconColumn,
  SourceColumn,
} from '../../grids/columns';
import { NoAwaitingShipmentReturnsPlaceholder } from '../../grids/placeholders/no-awaiting-shipment-returns-placeholder';

const columns = [
  RequestNumberColumn,
  StoreIconColumn,
  OrderNumberColumn,
  SourceColumn,
  CreateDateColumn,
  CustomerNameColumn,
  CustomerEmailColumn,
  AmountColumn,
];

const viewSpecificFilters: any[] = []; // oxlint-disable-line @typescript-eslint/no-explicit-any

export const SSRAwaitingShipmentGrid = () => {
  return (
    <SSRBaseGrid
      columns={columns}
      noResultsPlaceholder={<NoAwaitingShipmentReturnsPlaceholder />}
      viewSpecificFilters={viewSpecificFilters}
    />
  );
};
